import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/firstRecharge/walletFR.png'
import _imports_1 from '@/assets/home/game_arrow_white.png'
import _imports_2 from '@/assets/firstRecharge/DepoBtnFR.png'


const _hoisted_1 = { class: "firstRechargePage" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "firstRecharge" }
const _hoisted_4 = { class: "firstRecharge-left" }
const _hoisted_5 = { class: "firstRecharge-label" }
const _hoisted_6 = { class: "firstRecharge-amount" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = {
  key: 3,
  class: "tabs-container"
}
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 0,
  class: "immidiateDepositBtn"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "btn-text" }
const _hoisted_15 = ["title", "name"]
const _hoisted_16 = { class: "content" }
const _hoisted_17 = { class: "bottom_text" }
const _hoisted_18 = ["innerHTML"]

import { ref } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import DayListFirst from './components/dayListFirst.vue';
import NoData from '../components/common/noData.vue';
import CashbackHistoryPopup from './components/cashbackHistoryPopup.vue';
import { FirstRechargeData } from '@/view/firstRecharge/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'firstRecharge',
  props: {
    dataSet: {}
  },
  emits: ['checkScroll', 'scrollLeft', 'scrollRight', 'getClaim', 'goToDeposit'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const histryPopupRef = ref()
const active = ref(0);
const props = __props

const emits = __emit

const setActive = (value : number) => {
    active.value = value
}

const checkScroll = () => {
    emits('checkScroll')
};

const scrollLeft = () => {
    emits('scrollLeft')
};

const scrollRight = () => {
    emits('scrollRight')
};

const getClaim = () => {
    emits('getClaim')
}
const goToDeposit = (amount : any) => {
     emits("goToDeposit", amount)
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const resetHistoryData = () => {
    // historyList.value = []
}
__expose({
    setActive
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.first_recharge'),
      "show-history": true,
      onOpenHistoryPopup: openHistoryPopup
    }, null, 8, ["text"]),
    _createElementVNode("img", {
      class: "bg-top-img",
      src: _ctx.dataSet.bannerIcon
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          class: "wallet-icon"
        }, null, -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('activity.firstRecharge')) + ":", 1)
      ]),
      _createElementVNode("span", _hoisted_6, "R$ " + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.firstRechargeAmount)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.dataSet.showLeft)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_1,
            style: {"width":"5%","position":"absolute","top":"2vh","z-index":"200"},
            onClick: scrollLeft
          }))
        : _createCommentVNode("", true),
      (_ctx.dataSet.showRight)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_1,
            onClick: scrollRight,
            style: {"width":"5%","position":"absolute","transform":"rotate(180deg)","right":"0","top":"2vh","z-index":"200"}
          }))
        : _createCommentVNode("", true),
      (_ctx.dataSet.recordList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.recordList, (i, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "image-wrapper"
                }, [
                  _createVNode(DayListFirst, {
                    currenyLable: true,
                    valueOne: i?.coin,
                    valueTwo: i?.turnover,
                    labelOne: 'dayList.giftAmount',
                    labelTwo: 'dayList.turnoverTimes',
                    activityStatus: i?.status,
                    time: i?.rewardDate,
                    onGetClaim: getClaim,
                    "available-amount": i?.availableAmount,
                    "given-amount": i?.givenAmount
                  }, null, 8, ["valueOne", "valueTwo", "activityStatus", "time", "available-amount", "given-amount"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.dataSet.firstRechargeConfig)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.dataSet.isShowTabs)
              ? (_openBlock(), _createBlock(_component_van_tabs, {
                  key: 0,
                  active: active.value,
                  "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
                  ellipsis: false,
                  ref: "tabsRef",
                  onRendered: checkScroll
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.firstRechargeConfig?.config, (item, index) => {
                      return (_openBlock(), _createBlock(_component_van_tab, {
                        key: index,
                        title: item.title,
                        name: index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            (_ctx.dataSet.firstRechargeConfig?.firstRechargeEligible)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("div", {
                                    class: "depositBtn",
                                    onClick: ($event: any) => (goToDeposit(item.amount))
                                  }, [
                                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                                      src: _imports_2,
                                      class: "btn-icon-image"
                                    }, null, -1)),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('activity.immediateDeposit')) + " : " + _toDisplayString(item.amount), 1),
                                    _createVNode(_component_van_icon, {
                                      name: "arrow",
                                      class: "arrow-right"
                                    })
                                  ], 8, _hoisted_13)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.days, (i, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "image-wrapper"
                              }, [
                                _createVNode(DayListFirst, {
                                  currenyLable: true,
                                  day: i.day,
                                  valueOne: i.gift ? i.gift : 0,
                                  valueTwo: i.turnover_times,
                                  labelOne: 'dayList.giftAmount',
                                  labelTwo: 'dayList.turnoverTimes',
                                  activityStatus: i.activeStatus
                                }, null, 8, ["day", "valueOne", "valueTwo", "activityStatus"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["title", "name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["active"]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dataSet.firstRechargeConfig?.config, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    title: item?.title,
                    name: index
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.days, (i, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "image-wrapper"
                        }, [
                          _createVNode(DayListFirst, {
                            currenyLable: true,
                            day: i?.day,
                            valueOne: i?.gift ? i?.gift : 0,
                            valueTwo: i?.turnover_times,
                            labelOne: 'dayList.giftAmount',
                            labelTwo: 'dayList.turnoverTimes',
                            activityStatus: i?.activeStatus
                          }, null, 8, ["day", "valueOne", "valueTwo", "activityStatus"])
                        ]))
                      }), 128))
                    ])
                  ], 8, _hoisted_15))
                }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.dataSet.firstRechargeConfig && _ctx.dataSet.recordList.length == 0)
        ? (_openBlock(), _createBlock(NoData, { key: 4 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "6" }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "title"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "6" })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.formattedMessages, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line_text",
            key: index,
            innerHTML: item
          }, null, 8, _hoisted_18))
        }), 128))
      ]),
      _createVNode(CashbackHistoryPopup, {
        ref_key: "histryPopupRef",
        ref: histryPopupRef,
        list: _ctx.dataSet.historyList,
        title: _ctx.$t('activity.lossTotal'),
        onResetHistoryData: resetHistoryData,
        isUseFirstRecharge: true,
        isTabsContainerActive: _ctx.dataSet.isShowTabs
      }, null, 8, ["list", "title", "isTabsContainerActive"])
    ])
  ]))
}
}

})